import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Breadcrumb, Tabs, Button } from "antd";
import Main from "../../components/layout/Main";
import BreadcrumbArrow from "../../assets/images/breadcrumb-image-arrow.svg";
import TrofiesImage from "../../assets/images/trofies-image.svg";
import TumanentImage from "../../assets/images/tunamnet-tubhnail-image.jpg";

const { TabPane } = Tabs;

const tournaments = [
  {
    date: "27 March 2025 | 9:30 PM",
    slots: "5/5 slots",
    timeLeft: "14h 30min",
    status: "Active",
    trophies: ["Gold", "Silver", "Bronze"],
    game: "Assassin Creed – PVP",
    gameMode: "3v3",
    image: TumanentImage,
  },
  {
    date: "28 March 2025 | 8:00 PM",
    slots: "3/5 slots",
    timeLeft: "20h 10min",
    status: "Active",
    trophies: ["Gold", "Silver"],
    game: "Call of Duty – 1v1",
    gameMode: "1v1",
    image: TumanentImage,
  },
  {
    date: "29 March 2025 | 10:00 PM",
    slots: "2/5 slots",
    timeLeft: "1d 5h",
    status: "Active",
    trophies: ["Gold"],
    game: "FIFA Showdown",
    gameMode: "2v2",
    image: TumanentImage,
  },
];

const SelectedGamesTournaments = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("public");
  const [activeMode, setActiveMode] = useState("All");

  const filteredTournaments =
    activeMode === "All"
      ? tournaments
      : tournaments.filter((t) => t.gameMode === activeMode);

  return (
    <Main>
      <Breadcrumb
        className="for-route-path-head"
        separator={<img src={BreadcrumbArrow} alt=">" />}
      >
        <Breadcrumb.Item
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
        >
          Tournament
        </Breadcrumb.Item>
        <Breadcrumb.Item>Games</Breadcrumb.Item>
        <Breadcrumb.Item>Call of Duty</Breadcrumb.Item>
      </Breadcrumb>

      <div className="games-versoin-name-section">
        <div className="games-versoin-name-header">
          <h4>Call of Duty MW1 2019</h4>
        </div>

        <div className="games-tabs">
          <Tabs
            activeKey={activeTab}
            onChange={setActiveTab}
            className="custom-tabs"
          >
            <TabPane tab="Public" key="public" />
            <TabPane tab="Private" key="private" />
          </Tabs>
        </div>

        <div className="game-modes-filter">
          {["All", "3v3", "2v2", "1v1"].map((mode) => (
            <Button
              key={mode}
              type={activeMode === mode ? "primary" : "default"}
              onClick={() => setActiveMode(mode)}
              className="mode-filter-btn"
            >
              {mode}
            </Button>
          ))}
        </div>

        <div className="main-grid-class">
          {filteredTournaments.map((item, index) => (
            <div key={index} className="tournament-card">
              <div className="tunament-image">
                <img alt="thumbnail" src={item.image} />
              </div>

              <div className="card-top-info">
                <div className="tunament-date">{item.date}</div>
                <div className="starts-time">
                  Starts in: <span>{item.timeLeft}</span>
                </div>
              </div>

              <div className="card-tags">
                <img src={TrofiesImage} alt="Trophies" />
                <span>
                  {item.trophies.map((t, i) => (
                    <span key={i}>
                      {t}
                      {i < item.trophies.length - 1 ? ", " : ""}
                    </span>
                  ))}
                </span>
              </div>

              <div className="tunament-slot">{item.slots}</div>

              <div className="tunamnet-game-name-main">
                <div className="tunamnet-game-name">
                  <h5>
                    {item.game} <span>{item.status}</span>
                  </h5>
                </div>
                <Button className="join-button Fill-button">Join</Button>
              </div>
            </div>
          ))}
        </div>
        {activeTab === "private" && (
          <div className="create-private-tumanet-button">
            <Button className="private-tunament-button Fill-button" onClick={() => navigate("/create-tournaments")} >
              Create Tournaments
            </Button>
          </div>
        )}
      </div>
    </Main>
  );
};

export default SelectedGamesTournaments;
